export enum FileOpenEntryPoint {
    Unknown = 0,
    Protocol = 1,
    DragDrop = 2,
}
